const SPECIAL_PRODUCT_ACCENTS = ['#6366F1', '#0891B2', '#0D7377', '#7C3AED'];
const catalogLabelCollator = new Intl.Collator('fr', {
  sensitivity: 'base',
  numeric: true,
});

export function specialProductAccent(index: number): string {
  return SPECIAL_PRODUCT_ACCENTS[index % SPECIAL_PRODUCT_ACCENTS.length];
}

export function uniqueProductsById<T extends { id: string }>(groups: T[][]): T[] {
  return Array.from(
    new Map(groups.flat().map((product) => [product.id, product])).values(),
  );
}

export function sortCategoriesByName<T extends { name: string }>(
  categories: T[],
): T[] {
  return [...categories].sort((left, right) =>
    catalogLabelCollator.compare(left.name, right.name),
  );
}

export function sortProductsByCategoryThenName<
  TProduct extends { categoryId: string; name: string },
  TCategory extends { id: string; name: string },
>(products: TProduct[], categories: TCategory[]): TProduct[] {
  const categoryNames = new Map(
    categories.map((category) => [category.id, category.name]),
  );

  return [...products].sort((left, right) => {
    const categoryComparison = catalogLabelCollator.compare(
      categoryNames.get(left.categoryId) ?? left.categoryId,
      categoryNames.get(right.categoryId) ?? right.categoryId,
    );
    return categoryComparison !== 0
      ? categoryComparison
      : catalogLabelCollator.compare(left.name, right.name);
  });
}
